import React from 'react';
import Reveal from '../Reveal';

export const CsrHero = ({ hero }) => (
  <section className="relative overflow-hidden bg-ink px-6 pb-16 pt-32 text-center md:pt-36">
    <div className="relative z-10 mx-auto max-w-3xl">
      <Reveal>
        <div className="mb-9 flex items-center justify-center gap-6">
          <img
            src="/assets/khm-cares.png"
            alt="KHM Cares — Spreading Joy"
            className="h-24 w-24 rounded-full object-cover shadow-[0_10px_40px_rgba(227,167,43,0.25)] md:h-28 md:w-28"
          />
          <span className="font-serif text-3xl font-light text-gold">×</span>
          <span className="flex items-center bg-white px-4 py-2.5 shadow-[0_10px_40px_rgba(0,0,0,0.4)]">
            <img src="/assets/khm-events.png" alt="KHM Events Pakistan" className="h-10 w-auto md:h-12" />
          </span>
        </div>
      </Reveal>
      <Reveal delay={120}>
        <p className="mb-5 text-[10px] uppercase tracking-[0.5em] text-gold">{hero.label}</p>
      </Reveal>
      <Reveal delay={220}>
        <h1 className="font-serif text-4xl font-light leading-[1.08] tracking-[0.02em] text-white md:text-6xl">
          {hero.title}
        </h1>
      </Reveal>
      <Reveal delay={320}>
        <div className="mx-auto mt-7 h-px w-12 bg-gold" />
      </Reveal>
      <Reveal delay={400}>
        <p className="mx-auto mt-8 max-w-2xl text-base leading-relaxed text-neutral-300">{hero.text}</p>
      </Reveal>
    </div>
  </section>
);

export const CsrStats = ({ stats }) => (
  <section className="border-y border-white/10 bg-ink">
    <div className="mx-auto grid max-w-[1200px] grid-cols-1 divide-y divide-white/10 sm:grid-cols-3 sm:divide-x sm:divide-y-0">
      {stats.map((s, i) => (
        <Reveal key={s.label} delay={i * 120}>
          <div className="px-6 py-8 text-center">
            <p className="font-serif text-4xl font-light tracking-[0.05em] text-gold md:text-5xl">{s.value}</p>
            <p className="mt-3 text-[10px] tracking-[0.3em] text-neutral-400">{s.label}</p>
          </div>
        </Reveal>
      ))}
    </div>
  </section>
);
